import { comcastExtension } from '@cbsinteractive/avia-js-comcast';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { AviaExtension } from 'tag/ts/tag/player/adapters/avia/extensions/AviaExtension';
export class ComcastCapabilitiesExtension extends AviaExtension {
    package = comcastExtension;
    namespaceKey = 'plugin_comcast';
    constructor(argument) {
        super({
            ...argument,
            name: 'ComcastCapabilitiesExtension'
        });
    }
    shouldBeUsed() {
        if (!super.shouldBeUsed()) {
            return false;
        }
        const onComcastDevice = this.tag.params.SYSTEM.device === EmbedDevice.COMCAST;
        const html5Embed = this?.params?.SYSTEM?.embedType === EmbedType.HTML5;
        if (html5Embed && onComcastDevice) {
            this?.logger?.log('onComcastDevice detected:', this.tag.params.SYSTEM.device);
        }
        return html5Embed && onComcastDevice;
    }
}
